<template>
  <div>
    <section>
      <v-app-bar
        :clipped-left="clipped"
        color="#FFFFFF"
        fixed
        nav
        elevation="0"
        app
        :class="clipped ? 'clipped' : ''"
        style="border-radius: 0px; z-index: 9; height: 80px; padding-top: 10px; left: 0px;">
        <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/>
        
        <v-toolbar-title 
          class="d-flex align-center pl-0"
          :style="clipped ? 'padding-left: 6px;' : ''">
          <div v-if="clipped"
            class="mr-8">
            <v-img
              @click="clipped = false"
              contain
              width="40"
              height="40"
              alt="Mitra Warung"  
              :src="require('@/assets/logo/favicon.png')"
              class="ma-auto cursor-pointer">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>


          <!-- <v-chip
            :color="set_color"
            style="min-width: 120px; height: 43px; border-radius: 50px; justify-content: center">
            <span
              class="body-2 white--text mx-2"
              style="font-weight: 600;">
              {{ user.unit_title }}
            </span>
          </v-chip> -->
          <v-row class="d-flex align-center justify-center d-sm-none">
            <v-col cols="12" class="text-center">
              <v-img
                :src="require('@/assets/logo/logo_small.jpeg')"
                max-width="100"
                contain
                class="mx-auto"
              ></v-img>
            </v-col>
          </v-row>

          <!-- TABLET & DESKTOP: logo + nama cabang -->
          <v-row class="d-none d-sm-flex align-center justify-center text-center">
            <!-- Logo -->
            <v-col cols="12" sm="auto" class="pr-0">
              <v-img
                :src="company.logo !== undefined && company.logo !== '' ? company.logo : require('@/assets/logo/logo_small.jpeg')"
                max-width="175"
                contain
                class="mx-auto"
              ></v-img>
            </v-col>

            <!-- Branch Name -->
            <v-col cols="12" sm="auto" class="pl-0">
              <div class="black--text font-weight-bold">
                {{ user.branch_name }}
              </div>
            </v-col>
          </v-row>


          <!-- <v-chip
            class="ma-4 white--text px-8 font-weight-medium"
            style="height: 43px; border-radius: 50px;"
            color="#1814f3"
          >
          <v-icon left>
            mdi-domain
          </v-icon>

            <span
              class="body-2 white--text ml-1"
              style="font-weight: 600;">
              {{ user.branch_name }}
            </span>
          </v-chip> -->

          
        </v-toolbar-title>

        <v-spacer/>

        <!-- <div
          class="mr-7"
          style="width: 225px;">
          <v-text-field
            class="no_box"
            outlined
            rounded
            placeholder="Search for something"

            prepend-inner-icon="mdi-magnify"

  
            hide-details
  
            v-model="search">
          </v-text-field>
        </div>


        <div
          class="mr-7">
          <v-btn
            color="#F5F7FA"
            elevation="0"
            width="50"
            height="50"
            to="/setting?menu=profile"
            class="white--text"
            fab
          >
            <v-img 
              width="25px"
              height="25px"
              contain
              alt="Mitra Warung"  
              :src="require('@/assets/icon/settings.png')"
              class="ma-auto">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-btn>
        </div>

        <div
          class="mr-7">
          <v-btn
            color="#F5F7FA"
            elevation="0"
            width="50"
            height="50"
            class="white--text"
            fab
          >
            <v-img 
              width="25px"
              height="25px"
              contain
              alt="Mitra Warung"  
              :src="require('@/assets/icon/notification.png')"
              class="ma-auto">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-btn>
        </div> -->

        <!-- <v-avatar 
          size="50"
          class="mr-6">
          <v-img 
            width="100%"
            height="100%"
            alt="Mitra Warung"  
            @click="toMenu(menu.right[1])"
            :src="user.image_url !== undefined && user.image_url !== '' ? user.image_url : require('@/assets/image/member_default.png')"
            class="ma-auto">
            <template v-slot:placeholder>
              <v-row
                class="fill-height"
                align="center"
                justify="center">
                <v-progress-circular 
                  size="20"
                  indeterminate 
                  :color="set_color">
                </v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-avatar> -->
        <v-menu
          transition="slide-x-transition"
          bottom
          right
          offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-list 
              flat 
              dense
              color="transparent"
              style="max-width: 400px;">
              <v-list-item 
                v-bind="attrs"
                v-on="on"
                class="px-2"
                style="border-radius: 50px; background: #FFFFFF;">
                <v-list-item-avatar 
                  size="40"
                  class="mr-3">
                  <v-img 
                    width="100%"
                    height="100%"
                    alt="kominfoklaten"  
                    :src="user.image_url !== undefined && user.image_url !== '' ? user.image_url : require('@/assets/image/member_default.png')"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="body-2 font-weight-bold">
                    {{ user.name }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon>mdi-menu-down</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in menu.right"
              :key="index"
              @click="toMenu(item)">
              <v-list-item-content
                :style="index < menu.right.length - 1 ? 'border-bottom: 2px solid #f9f9f9;' : ''">
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

      </v-app-bar>

      <v-navigation-drawer
        v-model="drawer"
        width="280"
        color="#FFFFFF"
        dark
        fixed
        app>
        <div
          class="d-flex align-center justify-center cursor-pointer pa-3 py-1"
          style="height: 81px; background: #FFFFFF; border-bottom: 1px solid #E6EFF5;">
          <div
            class="d-flex align-center">
            <div v-if="!clipped"
              class="d-flex align-center justify-end">
              <!-- <v-img
                contain
                width="160"
                height="40"
                alt="Mitra Warung"  
                :src="require('@/assets/logo/Logo.png')"
                class="">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img> -->
            </div>

            <!-- <v-spacer v-if="!clipped" />

            <v-btn v-if="!clipped"
              @click="clipped = !clipped ? true : false"
              class="mr-3"
              style="position: absolute; right: 0;"
              icon>
              <v-icon
                large
                color="black">
                mdi-pan-left
              </v-icon>
            </v-btn> -->
          </div>
        </div>
        <v-list
          style="height: calc(100vh - 100px); overflow-y: auto; overflow-x: hidden;" class="mt-0">
          <v-list-item>
            <v-list-item-content>
                <v-list-item-title class="color-light-black">
                  Management
                </v-list-item-title>
              </v-list-item-content>
          </v-list-item>

          <div 
            v-for="(item, index) in menu.left"
            :key="index" 
            style="z-index: 50;">
            <v-list-item 
              v-if="item.sub_menu.length < 1"
              :to="item.link" 
              color="transparent"
              :style="clipped ? 'padding: 0px 13px;' : ''">
              <v-list-item-avatar
                size="40"
                tile
                class="mr-2">
                <v-img 
                  contain
                  width="22"
                  height="22"
                  alt="megavin"  
                  :src="item.link.split('/')[1] === $route.fullPath.split('/')[1] ? item.icon_color : item.icon_color"
                  class="ma-auto">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        size="20"
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  class="fs-15"
                    :class="item.link === $route.fullPath ? 'color-dark-black' : 'color-light-black'"
                    :style="item.link === $route.fullPath ? `color: #333333;` : 'color: #757575'">
                  {{ item.title }}  
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group
              v-if="item.title !== 'Konfigurasi' && item.sub_menu.length > 0 && item.id !== 101"
              v-model="item.active"
              :color="set_color"
              no-action
              :class="clipped ? 'clipped_header' : ''">
              <template v-slot:activator>
                <v-list-item-avatar
                  size="40"
                  tile
                  class="mr-2"
                  style="border-radius: 10px !important;">
                  <v-img 
                    contain
                    width="22"
                    height="22"
                    alt="megavin"  
                    :src="item.link.split('/')[1] === $route.fullPath.split('/')[1] || item.active ? item.icon_color : item.icon_color"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="fs-15"
                    :class="item.active ? 'color-dark-black' : 'color-light-black'"
                    :style="item.active === $route.fullPath ? `color: #333333;` : 'color: #757575'">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="(item_sub, index_sub) in item.sub_menu"
                :key="index_sub"
                @click="restartFilter(); restartFilterOrder()"
                :to="item_sub.link"
                color="transparent">
                <v-list-item-content :style="item_sub.link.split('/')[1] === $route.fullPath.split('/')[1] && item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? `background: #F6F6F6;` : ''" style="border-radius: 8px; padding-left: 12px; padding-right: 12px;">
                  <v-list-item-title
                    class="fs-12"
                    :style="item_sub.link.split('/')[1] === $route.fullPath.split('/')[1] && item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? `color: #333333;` : 'color: #757575'">
                    {{ item_sub.title }}
                  </v-list-item-title>
                  <v-divider vertical
                    style="border-color: rgb(246 246 246); position: absolute; left: 35px; top: 0px; border-width: 1.2px;">
                  </v-divider>
                  <div
                    style="height: 12px;
                    width: 20px;
                    border-left: 1px solid rgb(246 246 246);
                    border-bottom: 1px solid rgb(246 246 246);
                    position: absolute;
                    border-radius: 0px 0px 0px 8px;
                    left: 35px;
                    border-width: 2px;
                    top: 8px;">

                  </div>
                  <!-- <v-divider 
                    style="border-color: rgb(246 246 246); position: absolute; right: 0px; top: 0px; border-width: 1.2px;">
                  </v-divider> -->
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <div
              v-if="item.title === 'Konfigurasi' && item.sub_menu.length > 0">
              <div
                class="body-1 black--text text-uppercase pa-4"
                style="font-weight: 600;">
                <span v-if="clipped">
                  <v-img 
                    contain
                    width="22"
                    height="22"
                    alt="megavin"  
                    :src="item.icon"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </span>
                
                <span v-else>
                  {{ item.title }}
                </span>
              </div>

              <v-list-item
                v-for="(item_sub, index_sub) in item.sub_menu"
                :key="index_sub"
                :to="item_sub.link"
                color="transparent"
                :style="clipped ? 'padding: 0px 13px;' : ''">
                <v-list-item-avatar
                  size="40"
                  tile
                  class="mr-4"
                  :class="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? '' : 'box_false'"
                  :color="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? set_color_rgb_down : '#FFFFFF'"
                  :style="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? `border: 2px solid ${set_color};` : ''"
                  style="border-radius: 10px !important;">
                  <v-img 
                    contain
                    width="22"
                    height="22"
                    alt="megavin"  
                    :src="item_sub.icon"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>
                
                <v-list-item-content>
                  <v-list-item-title
                    class="body-2"
                    :class="item_sub.link === $route.fullPath ? '' : 'grey--text'"
                    :style="item_sub.link === $route.fullPath ? `color: ${set_color}; font-weight: 600;` : ''">
                    {{ item_sub.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>

          </div>
        </v-list>
      </v-navigation-drawer>
    </section>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        clipped: false,
        drawer: true,
        total: 0,
        search: '',
        menu: {
          right: [
            {
              title: 'Profile',
              type: 'profile',
              link: '/setting?menu=profile'
            },
            {
              title: 'Keluar',
              type: 'logout',
              link: '#'
            }
          ],
          left: []
        },
        process: {
          load: false
        }
      }
    },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/empty')
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      },
      reload () {
        return this.$store.state.reload
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      counter () {
        return this.$store.state.counter
      }
    },
    created () {
      
    },
    mounted () {
      const debounce = (fn) => {
        let frame;
        return (...params) => {
          if (frame) { 
            cancelAnimationFrame(frame)
          }
          frame = requestAnimationFrame(() => {
            fn(...params)
          })
        } 
      }

      const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY
      }

      document.addEventListener('scroll', debounce(storeScroll), { passive: true })
      storeScroll()

      this.menu.left = this.$store.state.menu
      
      // Sort menu agar Dashboard (id 122) selalu di paling atas
      this.sortMenuDashboardFirst()

      this.fetchConfig()
      TokenService.saveColor('#718EBF')

      this.$store.commit("setColor", '#718EBF')
    },
    methods: {
      async fetchConfig () {
        this.process.load = true

        let params = {
          // company_id: this.user.company_id
        }

        await get('admin/config', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {

            TokenService.saveCompany(JSON.stringify(res.results.data[0]))

            this.$store.commit("setCompany", res.results.data[0])

            // if (res.results.data[0].color.length > 0) {
            //   res.results.data[0].color.map((obj) => {
            //     if (obj.active) {
            //       TokenService.saveColor(obj.hex)

            //       this.$store.commit("setColor", obj.hex)
            //     }
            //   })
            // } else {
            //   TokenService.saveColor('#DD5826')

            //   this.$store.commit("setColor", '#DD5826')
            // }

            // this.styles()
          }
        })
      },
      sortMenuDashboardFirst () {
        // Cari index menu Dashboard atau id 122
        const dashboardIndex = this.menu.left.findIndex(item => 
          item.title === 'Dashboard' || item.id === 122
        )
        
        // Jika ditemukan dan bukan di posisi pertama, pindahkan ke atas
        if (dashboardIndex > 0) {
          const dashboardMenu = this.menu.left.splice(dashboardIndex, 1)[0]
          this.menu.left.unshift(dashboardMenu)
        }
      },
      restartFilter () {
        this.$store.commit("setCustomer", {}) 
      },
      restartFilterOrder () {
        this.$store.commit("setOrder", {}) 
      },
      async toMenu (item) {
        if (item.type === 'logout') {
          TokenService.removeToken()
              
          window.location = '/login'
        } else {
          this.$router.push(item.link)
        }
      },

      styles () {
        let style = document.createElement('style')
          
        // RESET STYLESHEET TO AUTO
        style.innerHTML = `
          .v-data-table table .v-data-table-header {
            color: white;
            // background-color: ${this.set_color}; !important;
          }
          .v-data-table table > thead > tr > th {
            // background: ${this.set_color};
          }

          .v-data-table table > tbody .v-data-table__selected .v-input--selection-controls__input {
            // color: ${this.set_color};
          }
          .v-data-table table > tbody .v-input--selection-controls__input .v-icon {
            // color: ${this.set_color};
          }


          #iw-container .iw-title {
            font-family: 'Open Sans Condensed', sans-serif;
            font-size: 22px;
            font-weight: 400;
            padding: 10px;
            background-color: ${this.set_color};
            color: white;
            margin: 0;
            border-radius: 2px 2px 0 0;
          }

          .v-slide-group__prev .v-icon {
            color: ${this.set_color}; !important;
          }

          .v-slide-group__next .v-icon {
            color: ${this.set_color}; !important;
          }

          .table-grid table > thead > tr > th:nth-child(1) {
            left: 0; 
            z-index: 5;
            // background: ${this.set_color};
          }

          .v-data-table table > tbody > tr:hover .text-start, table > tbody > tr:hover .text-center,  table > tbody > tr:hover .text-end {
            cursor: pointer;
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
            border-radius: 0px !important;
          }
          .v-data-table__selected .text-start, .v-data-table__selected .text-center, .v-data-table__selected .text-end {
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
            border-radius: 0px !important;
          }
        `

        // ADD TO APPENDCHILD
        document.head.appendChild(style)
      }
    }
  }
</script>

<style>
  .sub .v-list-item {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .clipped .v-toolbar__content {
    padding-left: 8px;
  }

  .v-navigation-drawer--mini-variant {
    width: 68px !important;
  }

  .clipped_header .v-list-group__header {
    padding: 0px 13px;
  }
</style>